<template>
  <v-select
    class="tema-combo"
    id="temas-select"
    v-model="chooseTemas"
    item-text="nome"
    :items="temas"
    label="Temas"
    :return-object=true
    placeholder="Temas"
    v-on:change="$emit('onChange', chooseTemas)"
    :disabled="disabled"
    multiple
  >
    <template slot="no-data"> Nenhum Tema </template>
  </v-select>
</template>

<script>
import { temaAPI } from '../API/temaAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppTemaCombobox',
  props: {
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadTemas()
  },
  methods: {
    ...mapActions(['setLoading']),
    loadTemas () {
      temaAPI
        .list()
        .then((resp) => {
          this.temas = resp.data
        })
        .catch(() => {
          this.$notification.error('Erro ao obter Temas')
        })
    }
  },
  data () {
    return {
      temas: [],
      chooseTemas: []
    }
  }
}
</script>

<style scoped>
.tema-eixo-combo{
      padding: 0 24px 20px;
}
</style>
